/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';
import { useTivoDispatch } from '../../core/tivo/tivo-redux-wrapper';
import {
    hideNoNetworkOverlay,
    showNoNetworkOverlay,
} from '../../store/overlay/nonetworkoverlay/nonetworkoverlay.reducers';
import { NetworkManager } from '../../core/network/NetworkManager';

const NoNetworkOverlay: FunctionComponent = (): JSX.Element => {
    const dispatch = useTivoDispatch();

    const onNetworkChangeCallback = (state) => {
        if (
            state === NetworkManager.NetworkState.GATEWAY_CONNECTED ||
            state === NetworkManager.NetworkState.INTERNET_CONNECTED
        ) {
            dispatch(hideNoNetworkOverlay());
        } else if (
            state === NetworkManager.NetworkState.GATEWAY_DISCONNECTED ||
            state === NetworkManager.NetworkState.INTERNET_DISCONNECTED
        ) {
            dispatch(showNoNetworkOverlay());
        }
    };

    useEffect(() => {
        const ref = NetworkManager.subscribe(onNetworkChangeCallback);
        return () => {
            NetworkManager.unsubscribe(ref);
        };
    }, []);

    return <></>;
};

export default NoNetworkOverlay;
